export default __webpack_public_path__ + "static/article-4-6a99447ee669eea27c4e7dbce7e252d2.jpg";